import { StepBackwardOutlined } from '@ant-design/icons';
import { Col, Row, Form, Input, InputNumber, Select } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { PageContext } from '../../../../lib/context';

const UsersForm = () => {
    const { form, _onFinish, display, option } = useContext(PageContext);
    const { Option } = Select;
    const [password, setPassword] = useState('');
    const [role, setRole] = useState<number>();

    const handleChange = (value: number) => {
        setRole(value);
    }

    const handlePass = (e:any) => {
        setPassword(e.target.value);        
    }

    return (
        <Form layout="vertical" form={form} onFinish={_onFinish}>
            <Row>
                <Col span={12}>
                    <Form.Item
                        label="Username"
                        name="username"
                        rules={[{ required: true, message: 'Username is required' }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item
                        label="Fullname"
                        name="full_name"
                        rules={[{ required: true, message: 'Fullname is required' }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>
            {display && <>
            <Row>
                <Col span={12}>
                    <Form.Item
                        label="Password"
                        name="password"
                        rules={[{ required: true, message: 'Password is required' }]}
                        >
                        <Input.Password
                            id="password"
                            placeholder="Password"
                            onChange={handlePass}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item
                        label="Confirm Password"
                        name="confirm_password"
                        dependencies={['password']}
                        hasFeedback
                        rules={[{ required: true, message: 'Password is required' },
                        ({getFieldValue}) => ({
                            validator(_, value) {
                                if(!value || getFieldValue('password') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('Password did not match'));
                            }
                        })
                        ]}
                        >
                        <Input.Password
                            id="passwordConfirmation"
                            placeholder="Confirm Password"
                        />
                    </Form.Item>
                </Col>
            </Row>
            </>}
            <Row>
                <Col span={12}>
                    <Form.Item
                        label="Role"
                        name="role_id"
                        rules={[{ required: true, message: 'Role is required' }]}    
                    >
                        <Select style={{ width: 200 }} onChange={handleChange} placeholder="Select Role" options={option}/>                          
                    </Form.Item>
                </Col>
            </Row>
            <Form.Item
                name="id"
                hidden={true}
            >
                <InputNumber />
            </Form.Item>
        </Form>
    );
};

export default UsersForm;
